import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
export const summary = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: summary.url(args, options),
    method: 'get',
})

summary.definition = {
    methods: ["get","head"],
    url: '/embarcacoes/{classified}/checkup/summary',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
summary.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return summary.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
summary.get = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: summary.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
summary.head = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: summary.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
const summaryForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: summary.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
summaryForm.get = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: summary.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::summary
* @see app/Http/Controllers/CheckupController.php:41
* @route '/embarcacoes/{classified}/checkup/summary'
*/
summaryForm.head = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: summary.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

summary.form = summaryForm

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
export const chat = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chat.url(args, options),
    method: 'get',
})

chat.definition = {
    methods: ["get","head"],
    url: '/embarcacoes/{classified}/checkup/chat',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
chat.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return chat.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
chat.get = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chat.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
chat.head = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: chat.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
const chatForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: chat.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
chatForm.get = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: chat.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckupController::chat
* @see app/Http/Controllers/CheckupController.php:73
* @route '/embarcacoes/{classified}/checkup/chat'
*/
chatForm.head = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: chat.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

chat.form = chatForm

/**
* @see \App\Http\Controllers\CheckupController::ask
* @see app/Http/Controllers/CheckupController.php:78
* @route '/embarcacoes/{classified}/checkup/chat'
*/
export const ask = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(args, options),
    method: 'post',
})

ask.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/checkup/chat',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckupController::ask
* @see app/Http/Controllers/CheckupController.php:78
* @route '/embarcacoes/{classified}/checkup/chat'
*/
ask.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return ask.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckupController::ask
* @see app/Http/Controllers/CheckupController.php:78
* @route '/embarcacoes/{classified}/checkup/chat'
*/
ask.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ask.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::ask
* @see app/Http/Controllers/CheckupController.php:78
* @route '/embarcacoes/{classified}/checkup/chat'
*/
const askForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ask.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::ask
* @see app/Http/Controllers/CheckupController.php:78
* @route '/embarcacoes/{classified}/checkup/chat'
*/
askForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ask.url(args, options),
    method: 'post',
})

ask.form = askForm

/**
* @see \App\Http\Controllers\CheckupController::optin
* @see app/Http/Controllers/CheckupController.php:116
* @route '/embarcacoes/{classified}/checkup/optin'
*/
export const optin = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: optin.url(args, options),
    method: 'post',
})

optin.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/checkup/optin',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckupController::optin
* @see app/Http/Controllers/CheckupController.php:116
* @route '/embarcacoes/{classified}/checkup/optin'
*/
optin.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return optin.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckupController::optin
* @see app/Http/Controllers/CheckupController.php:116
* @route '/embarcacoes/{classified}/checkup/optin'
*/
optin.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: optin.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::optin
* @see app/Http/Controllers/CheckupController.php:116
* @route '/embarcacoes/{classified}/checkup/optin'
*/
const optinForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: optin.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::optin
* @see app/Http/Controllers/CheckupController.php:116
* @route '/embarcacoes/{classified}/checkup/optin'
*/
optinForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: optin.url(args, options),
    method: 'post',
})

optin.form = optinForm

/**
* @see \App\Http\Controllers\CheckupController::events
* @see app/Http/Controllers/CheckupController.php:146
* @route '/embarcacoes/{classified}/checkup/events'
*/
export const events = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: events.url(args, options),
    method: 'post',
})

events.definition = {
    methods: ["post"],
    url: '/embarcacoes/{classified}/checkup/events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CheckupController::events
* @see app/Http/Controllers/CheckupController.php:146
* @route '/embarcacoes/{classified}/checkup/events'
*/
events.url = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { classified: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.slug
        : args.classified,
    }

    return events.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckupController::events
* @see app/Http/Controllers/CheckupController.php:146
* @route '/embarcacoes/{classified}/checkup/events'
*/
events.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: events.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::events
* @see app/Http/Controllers/CheckupController.php:146
* @route '/embarcacoes/{classified}/checkup/events'
*/
const eventsForm = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: events.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CheckupController::events
* @see app/Http/Controllers/CheckupController.php:146
* @route '/embarcacoes/{classified}/checkup/events'
*/
eventsForm.post = (args: { classified: string | number | { slug: string | number } } | [classified: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: events.url(args, options),
    method: 'post',
})

events.form = eventsForm

const checkup = {
    summary: Object.assign(summary, summary),
    chat: Object.assign(chat, chat),
    ask: Object.assign(ask, ask),
    optin: Object.assign(optin, optin),
    events: Object.assign(events, events),
}

export default checkup